import { render } from "./AddEtagere.vue?vue&type=template&id=e86edd4a&ts=true"
import script from "./AddEtagere.vue?vue&type=script&lang=ts"
export * from "./AddEtagere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__